import { useContext } from "react";
import { langContext } from "../../api/Lang";

const el = {
    viewHistory: "Ιστορικό κινήσεων πορτοφολιού",
    historyHeading: "Ιστορικό κινήσεων",
    empty: "Δεν υπάρχουν κινήσεις στο πορτοφόλι σου ακόμα.",
    badgeOrder: "Παραγγελία",
    badgeRefund: "Επιστροφή",
    legacyBalanceChange: "Ενημέρωση υπολοίπου",
    balanceAfter: "Υπόλοιπο",
    orderForDate: (orderDate: string) => `για ${orderDate}`,
    orderForDates: (orderDates: string[]) => `για ${orderDates.join(", ")}`,
    changeOrderRefundDetail: (orderDate: string) => `(αλλαγή παραγγελίας για ${orderDate})`,
    cancelOrderRefundDetail: (orderDate: string) => `(ακύρωση παραγγελίας για ${orderDate})`,
    topUp: "Ανανέωση πορτοφολιού",
    placeOrder: (orderDate: string) => `Παραγγελία για ${orderDate}`,
    changeOrderRefund: (orderDate: string) => `Επιστροφή (αλλαγή παραγγελίας για ${orderDate})`,
    cancelOrderRefund: (orderDate: string) => `Επιστροφή (ακύρωση παραγγελίας για ${orderDate})`,
    placePackage: (title: string) => `Αγορά πακέτου: ${title}`,
    placePackageGeneric: "Αγορά πακέτου σίτισης",
    adminCancelOrder: (orderDate: string) => `Ακύρωση παραγγελίας από το σχολείο για ${orderDate}`,
    adminCancelOrderRecipient: (orderDate: string) => `Ακύρωση παραγγελίας παιδιού από το σχολείο για ${orderDate}`,
    adminAdjustment: "Διόρθωση υπολοίπου",
    adminAdjustmentNote: (note: string) => `Διόρθωση υπολοίπου: ${note}`,
    winbankTopUp: "Ανανέωση από τράπεζα",
    legacyOrderRefund: "Επιστροφή παραγγελίας",
    showingMostRecent: (limit: number) => `Εμφανίζονται οι ${limit} πιο πρόσφατες κινήσεις.`,
    pageSummary: (from: number, to: number, total: number) => `${from}–${to} από ${total}`,
    emptyForSchoolYear: "Δεν υπάρχουν κινήσεις για αυτό το σχολικό έτος.",
    schoolYearLabel: "Σχολικό έτος",
};

const en: typeof el = {
    viewHistory: "Wallet activity history",
    historyHeading: "Wallet activity",
    empty: "No wallet activity yet.",
    badgeOrder: "Order",
    badgeRefund: "Refund",
    legacyBalanceChange: "Balance update",
    balanceAfter: "Balance",
    orderForDate: (orderDate: string) => `for ${orderDate}`,
    orderForDates: (orderDates: string[]) => `for ${orderDates.join(", ")}`,
    changeOrderRefundDetail: (orderDate: string) => `(order change for ${orderDate})`,
    cancelOrderRefundDetail: (orderDate: string) => `(order cancelled for ${orderDate})`,
    topUp: "Wallet top-up",
    placeOrder: (orderDate: string) => `Order for ${orderDate}`,
    changeOrderRefund: (orderDate: string) => `Refund (order change for ${orderDate})`,
    cancelOrderRefund: (orderDate: string) => `Refund (order cancelled for ${orderDate})`,
    placePackage: (title: string) => `Package purchase: ${title}`,
    placePackageGeneric: "Meal package purchase",
    adminCancelOrder: (orderDate: string) => `Order cancelled by school for ${orderDate}`,
    adminCancelOrderRecipient: (orderDate: string) => `Child order cancelled by school for ${orderDate}`,
    adminAdjustment: "Balance adjustment",
    adminAdjustmentNote: (note: string) => `Balance adjustment: ${note}`,
    winbankTopUp: "Bank top-up",
    legacyOrderRefund: "Order refund",
    showingMostRecent: (limit: number) => `Showing the ${limit} most recent entries.`,
    pageSummary: (from: number, to: number, total: number) => `${from}–${to} of ${total}`,
    emptyForSchoolYear: "No wallet activity for this school year.",
    schoolYearLabel: "School year",
};

const walletHistoryLangs = { el, en };

export type WalletHistoryStrings = typeof el;

export function useWalletHistoryStrings(): WalletHistoryStrings {
    const [lang] = useContext(langContext);
    return walletHistoryLangs[lang];
}
